import React from 'react';
import PropTypes from 'prop-types';

import NumberHelper from 'util/number_helper';
import Export from 'components/Explorer/Export';
import SaveSearch from 'components/Explorer/SaveSearch';
import SummaryBlock from 'components/Explorer/ContentPanel/SummaryBlock';
import helpFor from 'util/help.js';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const Summary = ({ latestChartDate }) => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('timeline/summary', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const loadingFailed = loading === Loading.ERROR;
  const totalOutputs = data?.total_outputs ?? null;

  const content = () => {
    if (loadingFailed) return I18n.t('Explorer.Timeline.Summary.error');
    if (totalOutputs === 0) return I18n.t('Explorer.Timeline.Summary.no_results');
    return (
      <>
        <p>
          {I18n.htmlSafe('Explorer.Timeline.Summary.research_outputs', {
            count: totalOutputs,
            formattedCount: NumberHelper.formatNumberWithDelimiter(totalOutputs)
          })}
        </p>
        <p>
          {I18n.htmlSafe('Explorer.Timeline.Summary.last_refreshed', {
            lastRefreshed: latestChartDate.calendar()
          })}
        </p>
      </>
    );
  };

  return (
    <SummaryBlock>
      {isLoading ? (
        I18n.t('Explorer.Timeline.Summary.loading')
      ) : (
        <>
          <div>{content()}</div>
          <Export endpoint="attention" resultsCount={totalOutputs} help={helpFor('attention')} />
          <SaveSearch endpoint="timeline" analyticsName="Timeline" />
        </>
      )}
    </SummaryBlock>
  );
};

Summary.propTypes = {
  latestChartDate: PropTypes.object.isRequired
};

export default Summary;
